import { userLogout } from '@app/src/views/Login/login/state/login/actions';
import { CONSTANTS } from '../validationReportToken/constants';
import * as actionTypes from './actionTypes';
import { serviceOperator, serviceRefreshToken } from './services';
import { openModal } from '@app/src/commons/modal/state/modals/actions';

const fetchOperatorRequest = () => ({
  type: actionTypes.FETCH_OPERATOR_REQUEST
});

const fetchOperatorFailure = (errorMessage: string, errorRol?: boolean) => ({
  type: actionTypes.FETCH_OPERATOR_FAILURE,
  errorMessage,
  errorRol
});

const fetchOperatorSuccess = (data) => ({
  type: actionTypes.FETCH_OPERATOR_SUCCESS,
  data
});

const fetchGetRefreshToken = () => ({
  type: actionTypes.FETCH_REFRESHTOKEN_REQUEST
});

export const fetchOperator = (url: string): Function => {
  return async dispatch => {
    dispatch(fetchOperatorRequest());
    try {
      const data = await serviceOperator.getData(url);
      await dispatch(fetchOperatorSuccess(data));
    } catch(e) {
      if (e.code === CONSTANTS.expiredAccessToken) {
        await dispatch(fetchRefreshToken(url));
        return;
      }
      if (e.code === CONSTANTS.errorValidationRole) {
        dispatch(fetchOperatorFailure('Error de validación de rol. Vuelva a iniciar sesión.', true));
        dispatch(openModal('CLOSE_SESSION_MODAL'));
        return;
      }
      dispatch(fetchOperatorFailure(e.message));
    }
  }
};

const fetchRefreshToken = (url) => {
  return async dispatch => {
    dispatch(fetchGetRefreshToken());
    try {
      const refreshToken = localStorage.getItem('refreshtoken');
      const { data } = await serviceRefreshToken.getData(refreshToken);
      const value = await serviceOperator.getData(url, data.accessToken);
      await dispatch(fetchOperatorSuccess(value));
    } catch (error) {
      await dispatch(userLogout())
    }
  }
}
